module.exports = __webpack_public_path__ + "img/row2.a35a8ba7.jpg";